module.exports = __webpack_public_path__ + "img/logo.fc71d360.png";